// extracted by mini-css-extract-plugin
module.exports = {"root":"root","colorWeak":"colorWeak","ant-layout":"ant-layout","ant-table":"ant-table","ant-table-thead":"ant-table-thead","ant-table-tbody":"ant-table-tbody"};
    if(module.hot) {
      // 1768634493466
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"/","hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  